import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AllocatedBalance, CreateAllocatedBalance, DepositBalance, TransferAllocatedBalanceRequest, WithdrawAllocatedBalanceRequest } from '../models/balance';
import { ResponseBase } from '../models/response-base';
import { LocalStoreKeys } from '../shared/helpers/localstorage/local-store';

@Injectable({
  providedIn: 'root'
})
export class BalanceService {

    private URL = environment.GATEWAY + 'balance';
    private URL_ALLOCATED = environment.GATEWAY + 'allocatedBalances';
    API: string = environment.API + "Portal/cedentes";

    private currentBalanceSubject: BehaviorSubject<number>;
    private currentAccountBalanceSubject: BehaviorSubject<number>;

    constructor(private http: HttpClient) {
        this.currentBalanceSubject = new BehaviorSubject<number>(JSON.parse(localStorage.getItem(LocalStoreKeys.currentBalance)));
        this.currentAccountBalanceSubject = new BehaviorSubject<number>(JSON.parse(localStorage.getItem(LocalStoreKeys.currentAccountBalance)));
    }

    public get currentBalanceValue(): number {
        return this.currentBalanceSubject.value;
    }

    public get currentAccountBalanceValue(): number {
        return this.currentAccountBalanceSubject.value;
    }

    setCurrentBalanceValue(newCurrentBalance: number) {
        localStorage.setItem(LocalStoreKeys.currentBalance, JSON.stringify(newCurrentBalance));
        this.currentBalanceSubject.next(newCurrentBalance);
    }

    setCurrentAccountBalanceValue(newCurrentAccountBalance: number) {
        localStorage.setItem(LocalStoreKeys.currentAccountBalance, JSON.stringify(newCurrentAccountBalance));
        this.currentAccountBalanceSubject.next(newCurrentAccountBalance);
    }

    // getSaldo(cedenteGuid: string): Observable<ResponseBase<SaldoPessoa[]>> {
    //     let headers = new HttpHeaders();
    //     headers = headers.append('no-loader', 'true');

    //     return this.http.get<ResponseBase<SaldoPessoa[]>>(`${this.API}/${cedenteGuid}/saldo`, {headers});
    // }

    // getSaldoAsync(cedenteGuid: string): Promise<ResponseBase<SaldoPessoa[]>> {
    //     let headers = new HttpHeaders();
    //     headers = headers.append('no-loader', 'true');

    //     return this.http.get<ResponseBase<SaldoPessoa[]>>(
    //         `${this.API}/${cedenteGuid}/saldo`, {headers}
    //     ).toPromise();
    // }

    // getSaldoFuturo(pessoaGuid: string) {

    //     let headers = new HttpHeaders();
    //     headers = headers.append('Gateway', 'true');
    //     return this.http.get<ResponseBase<SaldoResponse>>(`${this.URL}/saldo/futuro/${pessoaGuid}`, { headers });
    // }

    getTotalBalanceAvailable(assignorGuid: string) {
        return this.http.get<ResponseBase<number>>(`${this.URL}/assignors/${assignorGuid}/total-available`);
    }

    getCurrentAccountBalance(assignorGuid: string) {
        let headers = new HttpHeaders();
        headers = headers.append('no-loader', 'true');
        return this.http.get<ResponseBase<number>>(`${this.URL}/assignors/${assignorGuid}/current-account`, { headers });
    }

    getAllocatedBalances(assignorGuid: string) {
        let headers = new HttpHeaders();
        headers = headers.append('no-loader', 'true');
        return this.http.get<ResponseBase<AllocatedBalance[]>>(`${this.URL}/assignors/${assignorGuid}`, { headers });
    }

    getAllocatedBalance(allocatedBalanceId: number, assignorGuid: string) {
        return this.http.get<ResponseBase<AllocatedBalance>>(`${this.URL}/${allocatedBalanceId}/assignors/${assignorGuid}`);
    }

    createAllocatedBalance(assignorGuid: string, allocatedBalance: CreateAllocatedBalance) {
        return this.http.post<ResponseBase<any>>(`${this.URL}/assignors/${assignorGuid}/`, allocatedBalance );
    }

    updateAllocatedBalance(assignorGuid: string, allocatedBalance: CreateAllocatedBalance) {
        return this.http.put<ResponseBase<any>>(`${this.URL}/assignors/${assignorGuid}/`, allocatedBalance );
    }

    getDepositsTotalBalance(assignorGuid: string) {
        return this.http.get<ResponseBase<number>>(`${this.URL}/assignors/${assignorGuid}/total-deposits`);
    }

    getDepositsBalance(assignorGuid: string) {
        return this.http.get<ResponseBase<DepositBalance[]>>(`${this.URL}/assignors/${assignorGuid}/deposits`);
    }

    transferAllocatedBalance(transferAllocatedBalanceRequest: TransferAllocatedBalanceRequest) {
        return this.http.post<ResponseBase<boolean>>(`${this.URL}/transfer`, transferAllocatedBalanceRequest);
    }

    withdrawAllocatedBalance(withdrawAllocatedBalanceRequest: WithdrawAllocatedBalanceRequest) {
        return this.http.post<ResponseBase<boolean>>(`${this.URL}/withdraw`, withdrawAllocatedBalanceRequest);
    }
}
